import type { SVGProps } from 'react'

export const CompareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.16675 6.5C5.54746 6.5 6.66675 5.38071 6.66675 4C6.66675 2.61929 5.54746 1.5 4.16675 1.5C2.78604 1.5 1.66675 2.61929 1.66675 4C1.66675 5.38071 2.78604 6.5 4.16675 6.5ZM4.16675 6.5V12.3333C4.16675 12.7754 4.34234 13.1993 4.6549 13.5118C4.96746 13.8244 5.39139 14 5.83341 14H10.0001M10.0001 4H14.1667C14.6088 4 15.0327 4.17559 15.3453 4.48816C15.6578 4.80072 15.8334 5.22464 15.8334 5.66667V11.5M10.0001 4L12.5001 6.5M10.0001 4L12.5001 1.5M15.8334 11.5C14.4527 11.5 13.3334 12.6193 13.3334 14C13.3334 15.3807 14.4527 16.5 15.8334 16.5C17.2141 16.5 18.3334 15.3807 18.3334 14C18.3334 12.6193 17.2141 11.5 15.8334 11.5ZM10.0001 14L7.50008 11.5M10.0001 14L7.50008 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
